/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import { Check } from 'react-feather'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { noop } from '../../../../../helpers/utils'

function CareerInstructionForm({
  careerInstructionQuestion,
  setCareerInstructionQuestion,
  answerTextError,
  setAnswerTextError,
}) {
  const CheckboxWithGreenCheck = withStyles({})(Checkbox)
  const { t } = useTranslation()
  const [pqrIdError, setPqrIdError] = React.useState('')
  return (
    <>
      <Box pt={2} px={2} pb={1}>
        {careerInstructionQuestion.map((row, index) => {
          return (
            <Box p={2} className="program-border-box" mb={2} key={row.pq_id} width="100%">
              <Box display="flex" alignItems="center" mb={1}>
                <Typography component="h6" variant="body2" color="textPrimary" tabIndex={0}>
                  <Box
                    className="break-word"
                    component="span"
                    fontWeight="600"
                    fontSize="16px"
                    tabIndex={0}
                    display="flex"
                    alignItems="flex-start"
                    flexDirection="row"
                    color="var(--color-primary-grey)"
                  >
                    <Box component="span" mr={1}>
                      {index + 1 + '.'}
                    </Box>
                    {row.pq_question}
                  </Box>
                </Typography>
              </Box>
              {row.pq_question_type === 'radio' ? (
                <FormControl component="fieldset">
                  <RadioGroup aria-label="position" color="primary">
                    {row.pq_question_option.map((option) => {
                      return (
                        <FormControlLabel
                          key={option.pqo_id}
                          checked={option.enable === 'true'}
                          onChange={() => {
                            setCareerInstructionQuestion((careerInstructQuestion) =>
                              careerInstructQuestion.map((planItem) => {
                                if (planItem.pq_id === row.pq_id) {
                                  return {
                                    ...planItem,
                                    pq_question_option: planItem?.pq_question_option.filter(
                                      (item) => item.enable === 'true'
                                    ).length
                                      ? planItem.pq_question_option.map((optionItem) => {
                                          if (optionItem.pqo_id === option.pqo_id) {
                                            return {
                                              ...optionItem,
                                              enable: 'true',
                                            }
                                          } else if (optionItem.pqo_id !== option.pqo_id) {
                                            return {
                                              ...optionItem,
                                              enable: 'false',
                                            }
                                          }
                                          return optionItem
                                        })
                                      : planItem.pq_question_option.map((optionItem) => {
                                          if (optionItem.pqo_id === option.pqo_id) {
                                            return {
                                              ...optionItem,
                                              enable: 'true',
                                            }
                                          }
                                          return optionItem
                                        }),
                                  }
                                }
                                return planItem
                              })
                            )
                          }}
                          control={<Radio color="primary" />}
                          label={
                            <Box
                              style={{
                                textTransform: 'capitalize',
                              }}
                              fontWeight="fontWeightMedium"
                            >
                              {t(option.pqo_option)}
                            </Box>
                          }
                          labelPlacement="end"
                        />
                      )
                    })}
                  </RadioGroup>
                </FormControl>
              ) : row.pq_question_type === 'checkbox' ? (
                row.pq_question_option.map((option) => {
                  return (
                    <Box mt={1.5} display="flex" flexDirection="column" key={option.pqo_option}>
                      <Box pb={0} mt={0} className="custom-checkbox">
                        <FormControlLabel
                          control={
                            <CheckboxWithGreenCheck
                              checkedIcon={<Check />}
                              checked={option.enable}
                              onChange={() => {
                                setCareerInstructionQuestion((careerInstructQuestion) =>
                                  careerInstructQuestion.map((planItem) => {
                                    if (planItem.pq_id === row.pq_id) {
                                      return {
                                        ...planItem,
                                        pq_question_option: planItem.pq_question_option.map(
                                          (optionItem) => {
                                            if (optionItem.pqo_id === option.pqo_id) {
                                              return {
                                                ...optionItem,
                                                enable: !optionItem.enable,
                                              }
                                            }
                                            return optionItem
                                          }
                                        ),
                                      }
                                    }
                                    return planItem
                                  })
                                )
                              }}
                              color="primary"
                              id="frp_access_grades"
                              name="frp_access_grades"
                            />
                          }
                          label={<pre>{option.pqo_option}</pre>}
                        />
                      </Box>
                    </Box>
                  )
                })
              ) : (
                <Grid item xs={12}>
                  <TextField
                    className="custom-input-field"
                    multiline
                    rows={8}
                    rowsMax={8}
                    name="pqr_answer_text"
                    variant="outlined"
                    fullWidth
                    size="small"
                    id="pqr_answer_text"
                    data-pqid={row.pq_id}
                    defaultValue=""
                    value={row?.pqr_answer_text}
                    onChange={(event) => {
                      const answerText = event.target.value
                      const pqrId =
                        event.currentTarget.parentElement?.parentElement?.attributes['data-pqid']
                          ?.value
                      setPqrIdError(pqrId)
                      const schema = yup.object().shape({
                        pqr_answer_text: yup.string().max(1500),
                      })
                      schema
                        .validate({
                          pqr_answer_text: answerText,
                        })
                        .then(() => {
                          setAnswerTextError('')
                          setCareerInstructionQuestion((prevQuestions) =>
                            prevQuestions.map((planItem) =>
                              planItem.pq_id === row.pq_id
                                ? { ...planItem, pqr_answer_text: answerText }
                                : planItem
                            )
                          )
                        })
                        .catch((err) => setAnswerTextError(err.message))
                    }}
                  />
                  {answerTextError && pqrIdError == row.pq_id && (
                    <span tabIndex={0} className="error">
                      {t('error:answerTextMaxError')}
                    </span>
                  )}
                </Grid>
              )}
            </Box>
          )
        })}
      </Box>
    </>
  )
}

CareerInstructionForm.propTypes = {
  careerInstructionQuestion: PropTypes.array,
  setCareerInstructionQuestion: PropTypes.func,
  answerTextError: PropTypes.string,
  setAnswerTextError: PropTypes.func,
}
CareerInstructionForm.defaultProps = {
  careerInstructionQuestion: [],
  setCareerInstructionQuestion: noop,
  answerTextError: '',
  setAnswerTextError: noop,
}

export default CareerInstructionForm
